(()=>{
 const canonicalHost='www.nativo.health';
 if(!['www.nativo.health','nativo.health'].includes(location.hostname)){
   const canonical=new URL(location.href);canonical.hostname=canonicalHost;canonical.protocol='https:';
   location.replace(canonical.href);return;
 }
 const search=new URLSearchParams(location.search),safeSearch=new URLSearchParams();
 for(const key of ['o','utm_source','utm_medium','utm_campaign','utm_term','utm_content','utm_id','fbclid'])
   if(search.has(key))safeSearch.set(key,search.get(key));
 const frame=document.createElement('iframe');
 frame.id='nativo-plan-frame';frame.title='Tu plan de ajo añejado · Nativo';
 frame.setAttribute('sandbox','allow-scripts allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation');
 frame.name=safeSearch.toString();frame.referrerPolicy='no-referrer';
 frame.srcdoc=document.querySelector('#nativo-plan-document').content.textContent;
 document.querySelector('#nativo-plan-mount').append(frame);
 let checkoutPending=false;
 const allowedVariants=[53839940911317,53839940944085,54013153280213];
 window.addEventListener('message',async event=>{
  const data=event.data;
  if(event.source!==frame.contentWindow||event.origin!=='null'||data?.type!=='nativo-plan-checkout'||checkoutPending)return;
  if(!allowedVariants.includes(data.variant)||typeof data.subscription!=='boolean')return;
  checkoutPending=true;
  const item={id:data.variant,quantity:1};
  if(data.subscription)item.selling_plan=4695458005;
  try{
   const response=await fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})});
   if(!response.ok)throw new Error('cart_unavailable');
   const result=await response.json();
   if(!result.items?.some(line=>Number(line.variant_id||line.id)===data.variant))throw new Error('cart_not_confirmed');
   const checkout=new URL('/checkout',location.origin);
   for(const [key,value] of safeSearch)if(key!=='o')checkout.searchParams.set(key,value);
   location.assign(checkout.href);
  }catch(error){
   checkoutPending=false;
   frame.contentWindow.postMessage({type:'nativo-plan-checkout-error'},'*');
  }
 });
})();
